exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/monitoring/actual/politicallyexposed/politicallyexposedmatch/politically-exposed-match.component.css
// module id = 1965
// module chunks = 0